import React from 'react';
import { connect } from 'react-redux';
import I18n from '../../../blocks/localization';
import { Button, FormGroup, Input } from 'reactstrap';
import { ErrorMessage, Formik } from 'formik';
import { forgotPasswordValidationSchema } from '../../../blocks/validation/validationSchema';
import { ForgotPasswordRequest } from '../../../models/account/forgot-password/ForgotPasswordRequest';
import { forgotPasswordActions } from '../../../store/account/actions';
import ContentLayoutWithoutNavigation from '../../core/ContentLayoutWithoutNavigation';

type Props = typeof mapDispatchToProps;

const ForgotPassword = (props: Props) => {
    const initialForgotPasswordRequest = { email: '' } as ForgotPasswordRequest;

    const handleFormSubmit = (forgotPasswordRequest: ForgotPasswordRequest) => {
        props.forgotPassword(forgotPasswordRequest);
    }

    return (
        <ContentLayoutWithoutNavigation>
            <h1>{I18n.t('forgotPassword.title')}</h1>

            <Formik
                validationSchema={forgotPasswordValidationSchema}
                validateOnBlur
                initialValues={initialForgotPasswordRequest}
                enableReinitialize
                onSubmit={(values) => handleFormSubmit(values)}>
                {({ handleChange, handleSubmit, values, errors, touched }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <FormGroup>
                                <Input type="text" name="email" onChange={handleChange} placeholder={I18n.t('forgotPassword.form.email')}
                                    className={errors.email && touched.email ? ' is-invalid' : ''} />
                                <ErrorMessage name="email" component="div" className="invalid-feedback" />
                            </FormGroup>

                            <Button type="button" color="primary" onClick={handleSubmit}>{I18n.t('forgotPassword.button')}</Button>
                        </form>
                    );
                }}
            </Formik>
        </ContentLayoutWithoutNavigation>
    );
}

const mapDispatchToProps = {
    forgotPassword: forgotPasswordActions.request
};

export default connect(null, mapDispatchToProps)(ForgotPassword as any);
